<template>
     <div class="col-xl-6 col-lg-6">
            <div class="faq-content faq-white">
                <div class="accordion" id="accordionExample2">
                        <div class="accordion-item">
                           <h2 class="accordion-header" id="headingOne1">
                              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                 data-bs-target="#collapseOne1" aria-expanded="true" aria-controls="collapseOne1">
                                 How can we help your business?
                              </button>
                           </h2>
                           <div id="collapseOne1" class="accordion-collapse collapse show" aria-labelledby="headingOne1"
                              data-bs-parent="#accordionExample2">
                              <div class="accordion-body">
                                 <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                                    ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit
                                    esse cillum dolore eu fugiat nulla pariatur. </p>
                              </div>
                           </div>
                        </div>
                        <div class="accordion-item">
                           <h2 class="accordion-header" id="headingTw">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                 data-bs-target="#collapseTw" aria-expanded="false" aria-controls="collapseTw">
                                 What are the advantages of Binifox?
                              </button>
                           </h2>
                           <div id="collapseTw" class="accordion-collapse collapse" aria-labelledby="headingTw"
                              data-bs-parent="#accordionExample2">
                              <div class="accordion-body">
                                 <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                                    ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit
                                    esse cillum dolore eu fugiat nulla pariatur. </p>
                              </div>
                           </div>
                        </div>
                        <div class="accordion-item">
                           <h2 class="accordion-header" id="headingThree4">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                 data-bs-target="#collapseThree4" aria-expanded="false" aria-controls="collapseThree4">
                                 Let’s find an office near you?
                              </button>
                           </h2>
                           <div id="collapseThree4" class="accordion-collapse collapse" aria-labelledby="headingThree4"
                              data-bs-parent="#accordionExample2">
                              <div class="accordion-body">
                                 <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                                    ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit
                                    esse cillum dolore eu fugiat nulla pariatur. </p>
                              </div>
                           </div>
                        </div>
                        <div class="accordion-item">
                           <h2 class="accordion-header" id="headingThree5">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                 data-bs-target="#collapseThree5" aria-expanded="false" aria-controls="collapseThree5">
                                 Binifox WordPress theme for business?
                              </button>
                           </h2>
                           <div id="collapseThree5" class="accordion-collapse collapse" aria-labelledby="headingThree5"
                              data-bs-parent="#accordionExample2">
                              <div class="accordion-body">
                                 <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                                    ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit
                                    esse cillum dolore eu fugiat nulla pariatur. </p>
                              </div>
                           </div>
                        </div>
                        <div class="accordion-item">
                           <h2 class="accordion-header" id="headingThree6">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                 data-bs-target="#collapseThree6" aria-expanded="false" aria-controls="collapseThree6">
                                 Binifox WordPress theme for business?
                              </button>
                           </h2>
                           <div id="collapseThree6" class="accordion-collapse collapse" aria-labelledby="headingThree6"
                              data-bs-parent="#accordionExample2">
                              <div class="accordion-body">
                                 <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                                    ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit
                                    esse cillum dolore eu fugiat nulla pariatur. </p>
                              </div>
                           </div>
                        </div>
                        <div class="accordion-item">
                           <h2 class="accordion-header" id="headingThree7">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                 data-bs-target="#collapseThree7" aria-expanded="false" aria-controls="collapseThree7">
                                 Binifox WordPress theme for business?
                              </button>
                           </h2>
                           <div id="collapseThree7" class="accordion-collapse collapse" aria-labelledby="headingThree7"
                              data-bs-parent="#accordionExample2">
                              <div class="accordion-body">
                                 <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                                    ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit
                                    esse cillum dolore eu fugiat nulla pariatur. </p>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
   name:'FaqRight',
}
</script>